import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, useLocation } from 'react-router-dom'

import { sessionDataRedirect } from '../../features/session/sessionSlice'

function NoMatch({ redirect }){
    const dispatch = useDispatch()
    const location = useLocation()

    useEffect(() => {
        dispatch(sessionDataRedirect(location.pathname))
    }, [])

    return <Redirect to={redirect} />
}

NoMatch.defaultProps = {
    redirect: "/"
}

export default NoMatch